import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "userShieldFilled"
const UserShieldFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12 1.5S16.5 4.5 21 6C21 15.974 17.02 19.977 14.352 21.541L14.109 21.68C13.313 22.116 12.658 22.33 12.298 22.428 12.108 22.479 12 22.5 12 22.5S11.84 22.471 11.565 22.39Q11.512 22.375 11.455 22.355 11.383 22.336 11.306 22.31 11.165 22.26 11 22.199L10.944 22.175C10.703 22.08 10.428 21.96 10.13 21.808L10.114 21.798Q9.89 21.685 9.647 21.543 9.447 21.424 9.238 21.288 8.881 21.055 8.506 20.763C7.868 20.263 7.2 19.628 6.562 18.814Q6.28 18.458 6.008 18.054 5.862 17.838 5.72 17.608 5.426 17.132 5.15 16.594 4.881 16.07 4.636 15.487 4.242 14.55 3.926 13.437C3.67 12.535 3.456 11.543 3.3 10.453Q3.259 10.166 3.223 9.872 3.186 9.578 3.156 9.274 3.136 9.058 3.117 8.838 3.056 8.127 3.025 7.368 3 6.701 3 6C3.82 5.766 4.603 5.494 5.342 5.204Q5.564 5.117 5.78 5.027 6.022 4.927 6.257 4.821C7.217 4.404 8.087 3.966 8.84 3.547L9.469 3.187C10.354 2.668 11.036 2.204 11.468 1.896 11.814 1.648 12 1.5 12 1.5M12 15C10.022 15 8.605 15.396 7.664 15.815 7.257 15.995 6.942 16.18 6.711 16.335 7.298 17.387 7.94 18.195 8.56 18.815 9.536 19.79 10.5 20.348 11.203 20.66 11.54 20.811 11.814 20.901 12 20.956 12.186 20.902 12.461 20.81 12.797 20.661 13.499 20.35 14.464 19.791 15.44 18.814 16.06 18.194 16.7 17.386 17.288 16.334 17.057 16.179 16.742 15.995 16.336 15.814 15.395 15.397 13.978 15 12 15M12 6.75C10.343 6.75 9 8.093 9 9.75S10.343 12.75 12 12.75 15 11.407 15 9.75 13.657 6.75 12 6.75"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default UserShieldFilledIcon
